import React from "react";
import Layout from "../../../shared/Layout/Layout";
import NewsHeader from "../../../shared/Components/NewsHeader";
import PlanBreakDetails from "./components/PlanBreakDetails";

export default function PlanBreak() {
  return (
    <Layout>
      <NewsHeader>
        The plan to break systemic inertia and deliver impact transparency
      </NewsHeader>
      <PlanBreakDetails />
    </Layout>
  );
}
